module.exports = __webpack_public_path__ + "img/card-content-3.824c7cea.png";